import React, { memo } from 'react';
export function Footer() {
  return <footer className="border-t border-cozy-border bg-cozy-bg pt-16 pb-8" data-id="element-57">
      <div className="max-w-6xl mx-auto px-6" data-id="element-58">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-16" data-id="element-59">
          <div className="col-span-2" data-id="element-60">
            <a href="#" className="font-serif text-2xl tracking-tight text-cozy-text mb-4 block" data-id="element-61">
              getcozy
            </a>
            <p className="text-cozy-muted text-sm max-w-xs" data-id="element-62">
              Your AI, finally with memory that feels like home. Capture
              everything, ask anything, automate the rest.
            </p>
          </div>

          <div data-id="element-63">
            <h4 className="font-medium text-sm mb-4" data-id="element-64">Product</h4>
            <ul className="space-y-3 text-sm text-cozy-muted" data-id="element-65">
              <li data-id="element-66">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-67">
                  Features
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-69">
                  Integrations
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-71">
                  Pricing
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-73">
                  Changelog
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-74">
            <h4 className="font-medium text-sm mb-4" data-id="element-75">Resources</h4>
            <ul className="space-y-3 text-sm text-cozy-muted" data-id="element-76">
              <li data-id="element-77">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-78">
                  Documentation
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-80">
                  API Reference
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-82">
                  Blog
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-84">
                  Community
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-85">
            <h4 className="font-medium text-sm mb-4" data-id="element-86">Company</h4>
            <ul className="space-y-3 text-sm text-cozy-muted" data-id="element-87">
              <li data-id="element-88">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-89">
                  About
                </a>
              </li>
              <li data-id="element-90">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-91">
                  Careers
                </a>
              </li>
              <li data-id="element-92">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-93">
                  Legal
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="hover:text-cozy-text transition-colors" data-id="element-95">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-cozy-border text-sm text-cozy-muted" data-id="element-96">
          <p data-id="element-97">© {new Date().getFullYear()} GetCozy Inc. All rights reserved.</p>
          <div className="flex items-center gap-4 mt-4 md:mt-0" data-id="element-98">
            <span className="flex items-center gap-2" data-id="element-99">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-100"></span>
              All systems operational
            </span>
          </div>
        </div>
      </div>
    </footer>;
}